import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class StandardService {
    constructor(http) {
        this.http = http;
        this.singular = 'standard';
        this.plural = 'standards';
        this.editor = PLATFORM.moduleName('pages/standard-setup/standards/editor/index');
        this.configEditor = PLATFORM.moduleName('pages/standard-setup/standards/configuration/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`standards/filter/${loadOptions}`);
        return await response.json();
    }

    async filterConfigs(loadOptions, standardNumberId) {
        const response = await this.http.fetch(`standards/${standardNumberId}/filter/${loadOptions}`);
        return await response.json();
    }

    async create(standard) {
        await this.http.fetch('standards', { method: 'POST', body: json(standard) });
    }

    async createConfig(standardNumberId, standardConfig) {
        await this.http.fetch(`standards/${standardNumberId}`, { method: 'POST', body: json(standardConfig) });
    }

    async update(standard) {
        await this.http.fetch(`standards/${standard.id}`, { method: 'PUT', body: json(standard) });
    }

    async updateConfig(standardNumberId, standardConfig) {
        await this.http.fetch(`standards/${standardNumberId}/${standardConfig.id}`, { method: 'PUT', body: json(standardConfig) });
    }

    async delete(id) {
        await this.http.fetch(`standards/${id}`, { method: 'DELETE' });
    }

    async deleteConfig(standardNumberId, standardConfigId) {
        await this.http.fetch(`standards/${standardNumberId}/${standardConfigId}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`standards/${id}`);
        return await response.json();
    }

    async getConfigById(standardNumberId, standardConfigId) {
        const response = await this.http.fetch(`standards/${standardNumberId}/${standardConfigId}`);
        return await response.json();
    }

    async deleteGroup(standardGroupId) {
        await this.http.fetch(`standards/groups/${standardGroupId}`, { method: 'DELETE' });
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`standards/top-three/${query}`);
        return await response.json();
    }

    async getConfigsByNumberId(standardNumberId) {
        const response = await this.http.fetch(`standards/${standardNumberId}/configs`);
        return await response.json();
    }
}